import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { GeneratorsUiModule } from '@digital-platform/generators/ui';
import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { UsersUiModule } from '@digital-platform/users/ui';
import { WasteProfilesUiModule } from '@digital-platform/waste-profiles/ui';
import { EquipmentInfoFormComponent } from './equipment-info-form/equipment-info-form.component';
import { ServiceContactDialogComponent } from './service-contact-dialog/service-contact-dialog.component';
import { ServiceInfoFormComponent } from './service-info-form/service-info-form.component';
import { ServiceTilesComponent } from './service-tiles/service-tiles.component';
import { WasteInfoDetailsFormComponent } from './waste-info-details-form/waste-info-details-form.component';
import { WasteInfoFormComponent } from './waste-info-form/waste-info-form.component';
import { WasteServicesTableComponent } from './waste-services-table/waste-services-table.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiModule,
    SharedUiMaterialModule,
    ReactiveFormsModule,
    GeneratorsUiModule,
    UsersUiModule,
    WasteProfilesUiModule,
    RouterModule.forChild([])
  ],
  declarations: [
    WasteServicesTableComponent,
    ServiceTilesComponent,
    WasteInfoFormComponent,
    WasteInfoDetailsFormComponent,
    ServiceInfoFormComponent,
    EquipmentInfoFormComponent,
    ServiceContactDialogComponent
  ],
  exports: [
    WasteServicesTableComponent,
    ServiceTilesComponent,
    WasteInfoFormComponent,
    WasteInfoDetailsFormComponent,
    ServiceInfoFormComponent,
    EquipmentInfoFormComponent,
    ServiceContactDialogComponent
  ]
})
export class WasteServicesComponentsModule {}
